import type { BaseModel } from './common.types';

export enum BannerType {
  Critical = 'Critical',
  Warning = 'Warning',
  Info = 'Info'
}

export interface BannerModel extends BaseModel {
  content: string;
  type: BannerType;
  isActive: boolean;
  isClearable: boolean;
}

export interface ListBannersResponse {
  result: BannerModel[];
  count: number;
}

export interface CreateBannerParams {
  content: string;
  type: BannerType;
  isActive: boolean;
  isClearable: boolean;
}

export interface UpdateBannerParams extends CreateBannerParams {
  bannerId: string;
}

export interface DeleteBannerParams {
  bannerId: string;
}
